/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum GastherapyViewerAliases {
  EXECUTE_TIME_BUTTON = 'execute-time-button',
  EXECUTE_TIME_PANEL = 'execute-time-panel',
  GASTHERAPY_DETAILS_CARD = 'gastherapy-details-card',
  GASTHERAPY_FOOTER_PANEL = 'gastherapy-footer-panel',
  GASTHERAPY_VIEWER_CONTEXTUAL_BAR = 'gastherapy-viewer-contextual-bar',
  GASTHERAPY_VIEWER_DECK = 'gastherapy-viewer-deck',
  GASTHERAPY_VIEWER_LAYOUT = 'gastherapy-viewer-layout',
  GLOBAL_ACTIONS = 'global-actions',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INTERRUPT_BUTTON = 'interrupt-button',
  PANEL_GASTHERAPY_VIEWER_CONTENT = 'panel-gastherapy-viewer-content',
  PANEL_HEADER = 'panel-header',
  REVERT_GASTHERAPY_ACTION = 'revert-gastherapy-action',
  SUSPEND_GASTHERAPY_ACTION = 'suspend-gastherapy-action',
  TERMINATE_GASTHERAPY_ACTION = 'terminate-gastherapy-action',
}
export { GastherapyViewerAliases };
